export const resolveTransport = (stats: RTCStatsReport): 'udp' | 'tcp' | undefined => {
  let transportId: string | undefined;
  stats.forEach(r => {
    if (!transportId && r.type === 'inbound-rtp' && r.kind === 'video') {
      transportId = r.transportId;
    }
  });
  const pairId = transportId && stats.get(transportId)?.selectedCandidatePairId;
  const localId = pairId && stats.get(pairId)?.localCandidateId;
  const protocol = localId && stats.get(localId)?.protocol?.toLowerCase();
  return protocol === 'udp' || protocol === 'tcp' ? protocol : undefined;
};
